import { NewTag } from "@/components/Tag";
import { cn } from "@/lib/utils";

interface FilterSidebarItemProps {
  label: string;
  count: string;
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  isNew?: boolean;
}

export const FilterSidebarItem = ({
  label,
  count,
  icon,
  isActive,
  onClick,
  isNew,
}: FilterSidebarItemProps) => {
  return (
    <button
      className="flex items-center rounded-lg w-full cursor-pointer text-left"
      onClick={onClick}
    >
      <div className="flex-1 rounded-l-lg">
        <div
          className={cn(
            "flex-1 px-2.5 rounded-l transition-colors",
            isActive ? "bg-sky-900/50" : "bg-transparent hover:bg-sky-900/25",
          )}
        >
          <div className="flex items-center justify-between py-1">
            <div className="flex gap-2 items-center">
              <div className="size-4 shrink-0">{icon}</div>
              <span
                className={cn(
                  "text-sm ",
                  isActive ? "text-white" : "text-dark-secondary",
                )}
              >
                {label}
              </span>
              {isNew && <NewTag />}
            </div>
            <span className="text-sm text-dark-tertiary">{count}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center self-stretch">
        <div
          className={cn(
            "h-full w-1 rounded-sm transition-colors",
            isActive ? "bg-sky-700" : "bg-transparent",
          )}
        />
      </div>
    </button>
  );
};
